import { RandomId } from "@swivl-mono/helpers";
import { NodeData_LeasePicker, NodeInterface, NodeType, VarKey } from "@swivl-mono/types";
import { Checkbox, RadioButtons } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput } from "../../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const LeasePickerNode = {
  Type: NodeType.LeasePicker,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.LeasePicker,
      mode: "web",
      variableId: VarKey.UserLeaseId,
      initialMultipleLeasesMessage: "Please select your unit",
      shouldPickOnlyItemAutomatically: true,
      includeInactive: false,
      onPickedGoto: "",
      onlyItemAutomaticallyPickedGoto: "",
      noItemsGoto: "",
      voiceOptionsVariable: "User:LeaseOptionsFormatted",
      voiceOptionsSavedGoto: "",
      voiceOnlyLeaseVariable: VarKey.UserLeaseId
    } as NodeData_LeasePicker;
  },

  PlumbData: function (node: NodeInterface) {
    const n = node as NodeData_LeasePicker;
    const isVoice = n.mode === "voice";

    // First tab differs by mode
    const firstTab = isVoice
      ? { title: "Options Saved", id: "voiceOptionsSavedGoto", source: "voiceOptionsSavedGoto", target: n.voiceOptionsSavedGoto }
      : { title: "Lease Picked", id: "onPickedGoto", source: "onPickedGoto", target: n.onPickedGoto };

    const tabs = [firstTab, { title: "No Leases", id: "noItemsGoto", source: "noItemsGoto", target: n.noItemsGoto }];

    if (n.shouldPickOnlyItemAutomatically) {
      tabs.push({
        title: "Only Lease Picked",
        id: "onlyItemAutomaticallyPickedGoto",
        source: "onlyItemAutomaticallyPickedGoto",
        target: n.onlyItemAutomaticallyPickedGoto
      });
    }

    return TabNodeLayoutData({
      node: node,
      title: isVoice ? "Lease Picker (Voice)" : "Lease Picker",
      titleHeight: 45,
      baseWidth: 150,
      tabs
    });
  },

  InspectorPanel: class LeasePickerInspectorPanel extends NodePanel {
    handleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const mode = event.target.value as "web" | "voice";
      const node = { ...this.props.node } as NodeData_LeasePicker;
      node.mode = mode;
      this.props.updateNode(node, this.props.node, true);
    };

    render() {
      const node = this.props.node as NodeData_LeasePicker;
      const isVoiceMode = node.mode === "voice";

      return (
        <div>
          <div className="panel TableSaveRowPanel">
            <InspectorNodeHeader title="Lease Picker" id={node.id} />

            <label>Mode:</label>
            <RadioButtons
              options={[
                { value: "web", label: "Web (Buttons)" },
                { value: "voice", label: "Voice (Variables)" }
              ]}
              name="mode"
              value={node.mode || "web"}
              onChange={this.handleModeChange}
            />

            {isVoiceMode ? (
              <>
                <label>Save Formatted Options To</label>
                <UserVariablesDropdown
                  onChange={this.onChange}
                  skipUserId={true}
                  name="voiceOptionsVariable"
                  value={node.voiceOptionsVariable}
                  skipBotVariables={true}
                />
                {node.shouldPickOnlyItemAutomatically && (
                  <>
                    <label>Save Only Lease Picked To</label>
                    <UserVariablesDropdown
                      onChange={this.onChange}
                      skipUserId={true}
                      name="voiceOnlyLeaseVariable"
                      value={node.voiceOnlyLeaseVariable}
                      skipBotVariables={true}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <TagInput
                  label="Initial Multiple Lease Message"
                  key={"initialMultipleLeasesMessage" + this.props.node.id}
                  value={this.props.node.initialMultipleLeasesMessage}
                  onChange={this.onChange}
                  name="initialMultipleLeasesMessage"
                />

                <label>Save Selected Lease To</label>
                <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="variableId" value={node.variableId} skipBotVariables={true} />
              </>
            )}

            <Checkbox
              checked={node.shouldPickOnlyItemAutomatically}
              name={"shouldPickOnlyItemAutomatically"}
              onCheckedChange={(checked) => this.onChangeSwitch("shouldPickOnlyItemAutomatically", checked)}
              label="Automatically Pick if there is only one"
            />
            <Checkbox
              checked={node.includeInactive}
              name={"includeInactive"}
              onCheckedChange={(checked) => this.onChangeSwitch("includeInactive", checked)}
              label="Include Inactive Leases"
            />

            <InspectorFooter
              deleteNode={this.deleteNode}
              node={this.props.node}
              duplicateNode={this.props.duplicateNode}
              canDuplicate={this.props.canDuplicate}
            />
          </div>
        </div>
      );
    }
  }
};
export default LeasePickerNode;
